import { BaseComponent } from '../base-component.js';

export class AgTable extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-table"><slot></slot></div>`;
  }
}

customElements.define('ag-table', AgTable);
